import gql from 'graphql-tag';

import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { REGION_FIELDS } from '../../fragments/fence/region';
import { GetRegion, GetRegionVariables } from '../../athena/types/GetRegion';

export const GET_REGION = gql`
  query GetRegion($id: String) {
    fence {
      getRegion(input: { identifier: $id }) {
        region {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

const useGetRegion = (options?: QueryHookOptions<GetRegion, GetRegionVariables>) =>
  useQuery<GetRegion>(GET_REGION, options);

export default useGetRegion;
